import { render, staticRenderFns } from "./LayoutBlock.vue?vue&type=template&id=d211c9b6&"
import script from "./LayoutBlock.vue?vue&type=script&lang=js&"
export * from "./LayoutBlock.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBlock.vue?vue&type=style&index=0&id=d211c9b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports